
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Observable, debounceTime, map, startWith, switchMap } from 'rxjs';
import { AppError } from './app-error.type';
import { AppErrorsService } from './app-errors.service';

@Component({
    selector: 'app-errors',
    templateUrl: './app-errors.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppErrorsComponent implements OnInit {
    protected filteredErrors$: Observable<AppError[]>;
    protected searchResultNumber: number;
    protected searchInputCtrl = this._fb.nonNullable.control<string>('');

    private _errors$: Observable<AppError[]>;

    constructor(private appErrorsService: AppErrorsService, private _fb: FormBuilder) {
    }

    ngOnInit() {
        this._errors$ = this.appErrorsService.errors$;

        this.filteredErrors$ = this.searchInputCtrl.valueChanges.pipe(
            startWith(''),
            debounceTime(500),
            switchMap(() => this._errors$.pipe(
                map((errors) => {
                    return this.search(this.searchInputCtrl.value, errors);
                })
            )),

        );

        this.loadData();
    }

    private loadData() {
        this.appErrorsService.query()
    }

    delete(errorId: string) {
        this.appErrorsService.removeError([errorId]).then(() => {
            this.loadData();
        });
    }

    deleteAll(errors: AppError[]) {
        const errorIds = errors.map(error => error.id);
        this.appErrorsService.removeError(errorIds).then(() => {
            this.clear_search();
        });
    }

    private search(search_terms: string, errors: AppError[]) {
        function contains(value: string, term: string) {
            return value.toLowerCase().indexOf(term.toLowerCase()) !== -1;
        }

        search_terms = search_terms.trim();
        const emptySearch = search_terms === undefined;

        if (!emptySearch) {
            const filteredErrors = errors.filter(function (error) {
                return contains(error.message, search_terms) ||
                    contains(error.program, search_terms) ||
                    contains(error.hostname, search_terms) ||
                    contains(error.received_at, search_terms) ||
                    contains(error.source_name, search_terms) ||
                    contains(error.source_ip, search_terms) ||
                    contains(error.facility, search_terms) ||
                    contains(error.severity, search_terms)
            });

            this.searchResultNumber = filteredErrors.length

            return filteredErrors;
        }

        this.searchResultNumber = 0;

        return errors;
    }

    clear_search() {
        this.searchInputCtrl.setValue('');
        this.searchResultNumber = 0;
        this.loadData();
    }

}

